import { ParentAccountTransactionsRequest, TransactionsHistoryRequest } from 'vopay';

/**
 * The Transaction History list's request for a partner account's whole book: the account route's
 * request plus the one filter only the partner route has — the account to narrow the book to.
 */
export type PartnerTransactionsHistoryRequest = TransactionsHistoryRequest & {
  /** A VoPay account ID under the partner account; the route answers that account's transactions only. */
  VopayAccountID?: string;
};

/**
 * The Transaction History list's request, under `/partner/account/transactions`'s own names. The route
 * has no free-text search, so the keyword is sent as its `TransactionID` filter, as the partner's own
 * transactions page does; it has no flag, time zone or settlement-date filter and no PDF export, so
 * those are not sent — the list leaves them off its bar for this source.
 */
export default function toPartnerAccountTransactionsRequest({
  VopayAccountID,
  StartDateTime,
  EndDateTime,
  TransactionStatus,
  TransactionType,
  Currency,
  SearchText,
  Limit,
  Offset,
  IncludeSubaccountTransactions,
  ExportCSV,
}: PartnerTransactionsHistoryRequest): ParentAccountTransactionsRequest {
  return {
    VopayAccountID: VopayAccountID || undefined,
    FromDate: StartDateTime,
    ToDate: EndDateTime,
    Status: TransactionStatus ?? undefined,
    TransactionID: SearchText || undefined,
    TransactionType,
    Currency: Currency === 'All' ? undefined : Currency,
    Limit,
    Offset,
    IncludeSubaccountTransactions: IncludeSubaccountTransactions ?? undefined,
    ExportCSV,
  };
}
